module.exports = __webpack_public_path__ + "static/media/view2.47801194.jpg";